// extracted by mini-css-extract-plugin
module.exports = {"image":"xp","placeholder":"yp","videoPlaceholder":"zp","playVideoImgOverlay":"Ap","playVideoButton":"Bp","imageButton":"Cp","carouselChild":"Dp","compact":"Ep"};